import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-global.css'
import service from '../src/utils/request.js'
// 1. 导入路由实例（关键！）
import router from '../src/router/index.js' 
import '@fortawesome/fontawesome-free/css/all.min.css'

Vue.prototype.$axios = service
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  // 2. 挂载路由（关键！）
  router, 
  render: h => h(App),
}).$mount('#app')